import { Reducer } from 'redux'
import { IMarketplaceStore } from 'apps/marketplace/store/types'
import { TRANSFIX_LANE_ACTION_TYPES as c } from './actions'
import { ITransfixLaneState, ITransfixLaneResponse, ITransfixById } from './types'

const initState = {
  recentLaneId: '',
  dataById: undefined,
  loading: false,
  error: '',
}

type TransfixLaneActions =
  | { type: c.UPDATE_ASSIGN_LANE_REQUEST }
  | { type: c.UPDATE_ASSIGN_LANE_SUCCESS; payload: ITransfixLaneResponse }
  | { type: c.UPDATE_ASSIGN_LANE_FAILURE; error: string }
  | { type: c.DELETE_LANE_REQUEST }
  | { type: c.DELETE_LANE_SUCCESS; payload: ITransfixLaneResponse }
  | { type: c.DELETE_LANE_FAILURE; error: string }
  | { type: c.CLEAR_LANE_ERRORS }
  | { type: c.EDIT_LANE_ASSIGNMENT }

/** Reducer */
const transfixLaneReducer: Reducer<ITransfixLaneState, TransfixLaneActions> = (
  state: ITransfixLaneState = initState,
  action: TransfixLaneActions
): ITransfixLaneState => {
  switch (action.type) {
    case c.UPDATE_ASSIGN_LANE_REQUEST:
    case c.DELETE_LANE_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case c.UPDATE_ASSIGN_LANE_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: {
          ...state.dataById,
          [action.payload.transfixLane.id]: action.payload,
        },
        recentLaneId: action.payload.transfixLane.id,
      }
    case c.DELETE_LANE_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: {
          ...state.dataById,
          [action.payload.id]: action.payload,
        },
        recentLaneId: action.payload.id,
      }
    case c.UPDATE_ASSIGN_LANE_FAILURE:
    case c.DELETE_LANE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    case c.CLEAR_LANE_ERRORS:
      return {
        ...state,
        error: '',
      }
    case c.EDIT_LANE_ASSIGNMENT:
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default transfixLaneReducer

/** Selectors */
export const selectTransfixLane = (state: IMarketplaceStore): ITransfixById | undefined =>
  state.transfixLane.dataById

export const selectTransfixLaneError = (state: IMarketplaceStore): string =>
  state.transfixLane.error

export const isTransfixLaneLoading = (state: IMarketplaceStore): boolean =>
  state.transfixLane.loading

export const selectRecentUpdatedLaneId = (state: IMarketplaceStore): string =>
  state.transfixLane.recentLaneId
